<div class="chat-bubble-container">
  <img src="assets/images/{{environment.chatLogo}}" alt="Thumbnail" class="chat-thumbnail">
  <div class="chat-bubble">
    <p>{{ 'chat.queryError' | translate}}</p>
    <i class="bi bi-arrow-counterclockwise mr-1" data-bs-toggle="tooltip" data-bs-placement="top" (click)="reloadPage()" style="cursor:pointer"></i>
   @if (message?.messageType == MessageType.TOOL_SELECTOR &&  message?.messageStatus==MessageStatus.TOOL_EXECUTION_PENDING){
     <i class="bi bi-x-circle mr-1 deleteStep" (click)="deleteStep()"  style="cursor: pointer"></i>
   }

  </div>
</div>

